import { render, staticRenderFns } from "./V2ShipAllProductStep.vue?vue&type=template&id=61859ca2&scoped=true&"
import script from "./V2ShipAllProductStep.vue?vue&type=script&lang=js&"
export * from "./V2ShipAllProductStep.vue?vue&type=script&lang=js&"
import style0 from "./V2ShipAllProductStep.vue?vue&type=style&index=0&id=61859ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61859ca2",
  null
  
)

export default component.exports